





































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getColor } from '@/modules/_common/utils/getColor';
import { Pagination } from '../../../core';
@Component({
  name: 'CommonTable',
})
export default class CommonTable extends Vue {
  @Prop() readonly headers: any[];
  @Prop() readonly dataLoading: boolean;
  @Prop() readonly pagination: Pagination;
  // @Prop() readonly pageCount: number;
  @Prop() readonly items: any[];
  @Prop() readonly path: string;
  @Prop() readonly listCount: number;
  @Prop({ default: true }) readonly showPagination: boolean;

  get pageCount(): number {
    return Math.ceil(this.listCount / this.pagination.limit);
  }
  @Watch('pagination', {
    deep: true,
  })
  paginationChanged() {
    this.$emit('paginationChanged');
  }

  getColor(status) {
    return getColor(status);
  }

  onRowClicked(value) {
    this.$emit('rowClicked', value);
  }
}
